module.exports = __webpack_public_path__ + "img/32.2808a2cd.jpg";